exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3_VLi{position:fixed;top:0;left:0;right:0;bottom:0;z-index:2001;display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;justify-content:center;background-color:rgba(22,45,61,.8);opacity:0;transition:opacity .2s}._3_VLi._1tiA2{opacity:1}._3I8Zz{position:relative;overflow:hidden;width:495px;max-width:calc(100% - 60px);border-radius:8px;background:#fff;box-shadow:0 0 14px 0 rgba(29,45,60,.3)}.Q2mjk{padding:31px 30px 27px;color:#2b5672;font-family:HelveticaNeueW01-45Ligh,HelveticaNeueW02-45Ligh,HelveticaNeueW10-45Ligh,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:16px;line-height:22px;font-weight:300}._24mD7{display:block;padding:26px 23px;background-color:#f9fdff}._24mD7 .Q2mjk{height:100%;padding:14px 17px}._24mD7 ._1NwhM{position:absolute;z-index:1;top:14px;right:14px;width:14px;height:14px;border-radius:0;color:#2b2b2b;font-size:14px;background:none;opacity:.3;transition:opacity .2s}._24mD7 ._1NwhM:hover{background:none;opacity:.5}._11ozG{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;padding:0 24px 30px}._1bbiM{min-width:96px;height:30px;margin-left:18px;font-family:HelveticaNeueW01-55Roma,HelveticaNeueW02-55Roma,HelveticaNeueW10-55Roma,Helvetica Neue,ruble,Helvetica,Arial,sans-serif;font-size:14px}._3ghgr{width:500px;height:555px}._3OQu8{height:100%;padding:0}.ZqQ7a{border:none;border-radius:8px}.ZqQ7a,.reCAs{width:100%;height:100%}", ""]);

// exports
exports.locals = {
	"modal": "_3_VLi",
	"open": "_1tiA2",
	"window": "_3I8Zz",
	"content": "Q2mjk",
	"overlay-modal": "_24mD7",
	"overlayModal": "_24mD7",
	"close-button": "_1NwhM",
	"closeButton": "_1NwhM",
	"buttons": "_11ozG",
	"button": "_1bbiM",
	"iframe-modal-window": "_3ghgr",
	"iframeModalWindow": "_3ghgr",
	"iframe-modal-content": "_3OQu8",
	"iframeModalContent": "_3OQu8",
	"iframe": "ZqQ7a",
	"simple-modal-content": "reCAs",
	"simpleModalContent": "reCAs"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/shared/components/modal/modal.styl
// module id = 664
// module chunks = dashboard/dashboard widget/widget mobile/mobile mobile-overlay/mobile-overlay full-screen-modals/full-screen-modals business-manager/video-library-page